module.exports = __webpack_public_path__ + "img/ppt-1.beaec0fc.webp";